import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Acbushireinpune() {



const cardData =
  {
    keyword: 'AC Bus Hire in Pune',
    heading: 'Sanavi Travels: AC Bus Hire in Pune',
    headingDescription: 'Sanavi Travels offers premium, reliable, and comfortable AC Bus Hire in Pune for all types of group travel needs. Pune is a fast-growing metropolitan city with high travel demand from corporate offices, IT parks, educational institutions, wedding venues, tourist groups, and outstation travelers. In a city known for heavy traffic, long travel hours, and frequent outstation movement, air-conditioned bus travel ensures comfort, reduced fatigue, and a pleasant journey experience. Sanavi Travels provides a well-maintained fleet of modern AC buses, including luxury AC coaches, mini AC buses, and high-capacity AC buses suitable for city travel, highways, and long-distance routes. Each AC bus is equipped with powerful cooling systems, cushioned seating, ample legroom, clean interiors, smooth suspension, and sufficient luggage space to accommodate passengers traveling for weddings, corporate events, school trips, picnics, and family tours. Our experienced drivers are well familiar with Pune city routes, traffic patterns, IT corridors, industrial areas, and major highways, ensuring punctual pickups, disciplined driving, and smooth coordination throughout the journey. With transparent pricing, flexible rental packages, and 24/7 customer support, Sanavi Travels makes AC bus rental in Pune convenient, affordable, and stress-free for every group size and travel purpose.',

    top: 'Popular Routes, Locations, and Uses for AC Bus Hire in Pune',


"topPlaces": [
  {
    "title": "Pune City Travel and Daily Group Movement",
    "description": "Pune city sees constant movement of corporate teams, students, families, and tourists across areas like Shivajinagar, Hadapsar, Baner, Wakad, Hinjewadi, Kothrud, and Viman Nagar. AC buses are preferred for city travel due to traffic congestion and long commute times. Hiring an AC bus ensures passengers remain comfortable, calm, and refreshed throughout the journey, especially during peak hours and summer months."
  },
  {
    "title": "Corporate and IT Parks",
    "description": "Major IT and corporate hubs such as Hinjewadi, Magarpatta, Kharadi, Talawade, and Pimpri-Chinchwad generate high demand for AC bus services. Companies rely on AC buses for employee transportation, corporate outings, conferences, training programs, and office events. Air-conditioned buses help maintain a professional travel experience for employees and clients."
  },
  {
    "title": "Educational Institutions and School Trips",
    "description": "Pune is an educational hub with schools, colleges, and universities frequently organizing excursions, competitions, and industrial visits. AC buses provide a safe, comfortable, and controlled environment for students and teachers, especially during long travel hours and hot weather conditions."
  },
  {
    "title": "Wedding and Event Venues",
    "description": "Pune hosts numerous wedding halls, lawns, resorts, and convention centers. AC buses are highly preferred for wedding guest transportation, ensuring elders, children, and guests in traditional attire travel comfortably without heat or fatigue."
  },
  {
    "title": "Picnic and Leisure Destinations",
    "description": "Groups often travel from Pune to nearby picnic spots, dams, hills, and nature locations. AC bus hire makes picnic travel enjoyable by offering cool interiors, relaxed seating, and smooth rides for families, schools, and corporate teams."
  },
  {
    "title": "Outstation Tourist Routes",
    "description": "Popular outstation routes from Pune include Mumbai, Lonavala, Mahabaleshwar, Shirdi, Nashik, Satara, Kolhapur, and Goa. AC buses are ideal for long-distance travel, reducing travel fatigue and ensuring a pleasant journey."
  },
  {
    "title": "Religious and Spiritual Travel",
    "description": "Devotees often travel in groups from Pune to temples and spiritual destinations. AC buses provide comfort for elders and families, especially during full-day or overnight religious tours."
  },
  {
    "title": "Airport and Railway Transfers",
    "description": "AC bus hire is commonly used for transporting large groups to and from Pune airport and railway stations, ensuring coordinated arrivals and departures with comfort."
  },
  {
    "title": "Industrial and MIDC Areas",
    "description": "Industrial zones around Pune frequently require AC bus services for staff movement, inspections, and official visits, especially during long working hours and summer seasons."
  },
  {
    "title": "Family and Group Tours",
    "description": "Families planning group tours, celebrations, or long-distance travel prefer AC buses for a relaxed and enjoyable travel experience for all age groups."
  }
]
,



"services": [
{
"name": "AC Bus Hire in Pune",
"description": "AC Bus Hire in Pune offers premium group transportation designed to provide maximum comfort, convenience, and reliability for city and outstation travel. With Pune’s climate, traffic, and long commute durations, air-conditioned buses ensure passengers remain cool and relaxed throughout the journey. Sanavi Travels provides modern AC buses with powerful cooling systems, comfortable cushioned seating, ample legroom, smooth suspension, and clean interiors. This service is ideal for corporate travel, weddings, school trips, picnics, family tours, religious journeys, and long-distance travel, ensuring a stress-free and enjoyable experience for all passengers."
},
{
"name": "AC Bus on Rent Pune",
"description": "AC Bus on Rent Pune provides flexible rental options including hourly, full-day, event-based, and outstation packages. This service eliminates the hassle of coordinating multiple vehicles, allowing groups to travel together comfortably in a controlled and climate-friendly environment."
},
{
"name": "Luxury AC Bus Rental Pune",
"description": "Luxury AC Bus Rental Pune delivers an enhanced travel experience with premium interiors, superior seating comfort, refined ambience, and professional presentation. It is ideal for VIP guests, corporate executives, weddings, and high-profile events where comfort and image matter."
},
{
"name": "32 Seater AC Bus Hire Pune",
"description": "32 Seater AC Bus Hire Pune is suitable for medium-sized groups such as schools, offices, wedding guests, and tour groups. It offers balanced seating capacity with excellent cooling and comfort for both city and highway travel."
},
{
"name": "35 Seater AC Bus on Rent Pune",
"description": "35 Seater AC Bus on Rent Pune supports larger group travel requirements including corporate events, conferences, weddings, and long-distance tours, ensuring comfortable seating and effective cooling for all passengers."
},
{
"name": "AC Bus for Corporate Events Pune",
"description": "AC Bus for Corporate Events Pune provides professional and punctual transport for meetings, conferences, employee outings, seminars, and training programs, ensuring a comfortable and productive travel environment."
},
{
"name": "AC Bus for Wedding Pune",
"description": "AC Bus for Wedding Pune ensures comfortable and dignified transportation for wedding guests, especially elders and families, during multiple ceremonies and long event days."
},
{
"name": "AC Bus for Outstation Travel Pune",
"description": "AC Bus for Outstation Travel Pune offers reliable and comfortable long-distance transportation to popular tourist and religious destinations, reducing travel fatigue and enhancing the journey experience."
},
{
"name": "Mini AC Bus Hire Pune",
"description": "Mini AC Bus Hire Pune is ideal for small to medium-sized groups, offering flexibility, easy movement in city traffic, and affordable AC comfort."
},
{
"name": "AC Bus Rental for Picnic Pune",
"description": "AC Bus Rental for Picnic Pune ensures safe, cool, and enjoyable travel for school picnics, corporate outings, and family leisure trips."
},
{
"name": "Affordable AC Bus Hire Pune",
"description": "Affordable AC Bus Hire Pune delivers cost-effective air-conditioned travel solutions without compromising on vehicle quality, cleanliness, or service reliability."
},
{
"name": "Best AC Bus Service Pune",
"description": "Best AC Bus Service Pune is trusted for punctual service, well-maintained buses, professional drivers, and customer satisfaction provided by Sanavi Travels."
},
{
"name": "AC Bus Hire with Driver Pune",
"description": "AC Bus Hire with Driver Pune provides chauffeur-driven buses where experienced drivers manage routes, traffic, and schedules professionally."
},
{
"name": "AC Bus for School Trips Pune",
"description": "AC Bus for School Trips Pune ensures student safety, comfort, and discipline during educational tours and excursions."
},
{
"name": "AC Bus for Family Trip Pune",
"description": "AC Bus for Family Trip Pune offers relaxed and enjoyable group travel for families planning tours, celebrations, and outstation journeys."
}
],
"tableData": [
["AC Bus Hire in Pune", "AC Bus on Rent Pune"],
["Luxury AC Bus Pune", "Mini AC Bus Pune"],
["32 Seater AC Bus Pune", "35 Seater AC Bus Pune"],
["AC Wedding Bus Pune", "AC Corporate Bus Pune"],
["AC Picnic Bus Pune", "AC School Bus Pune"],
["AC Outstation Bus Pune", "AC Bus with Driver Pune"],
["Affordable AC Bus Pune", "Best AC Bus Service Pune"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "AC Bus Hire in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers premium air-conditioned buses with professional service across Pune."
  },
  {
    "WhyChooseheading": "Powerful and Reliable AC Systems",
    "WhyChoosedescription": "All AC buses are equipped with effective cooling systems suitable for long journeys."
  },
  {
    "WhyChooseheading": "Experienced Drivers",
    "WhyChoosedescription": "Drivers are trained for city and highway driving with disciplined service."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Interiors",
    "WhyChoosedescription": "Buses are cleaned, sanitized, and maintained for maximum passenger comfort."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear and honest pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hourly, daily, event-based, and outstation rental plans available."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Round-the-clock assistance for booking and journey coordination."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Service",
    "WhyChoosedescription": "On-time pickups and smooth journey execution."
  }
]

}

const faqData = [
  {
    question: 'Do you provide AC bus hire services in Pune?',
    answer: 'Yes, Sanavi Travels offers complete AC bus hire services across Pune.'
  },
  {
    question: 'Are AC buses available for weddings and corporate events?',
    answer: 'Yes, AC buses are available for weddings, corporate events, and group travel.'
  },
  {
    question: 'Can I book an AC bus for outstation travel from Pune?',
    answer: 'Yes, AC buses are available for long-distance and outstation journeys.'
  },
  {
    question: 'Are drivers included with AC bus hire?',
    answer: 'Yes, all AC bus rentals include experienced professional drivers.'
  },
  {
    question: 'Are AC buses cleaned and sanitized?',
    answer: 'Yes, all AC buses are cleaned and sanitized before every trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'We hired an AC bus in Pune for a corporate trip. Very comfortable and professional service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Ritu Shah',
    feedback: 'Excellent AC bus service for our family tour from Pune. Highly recommended.',
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







// const jsonData = {
//   "@context": "https://schema.org",
//   "@type": "Product",
//   "name": "AC Bus Hire in Pune - Sanavi Travels",
//   "description": "Sanavi Travels offers AC bus hire in Pune for corporate events, weddings, outstation travel, school trips, family trips, picnics, and more. We provide luxury AC buses, mini AC buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
//   "aggregateRating": {
//     "@type": "AggregateRating",
//     "bestRating": "5",
//     "worstRating": "1",
//     "ratingValue": "4.7",
//     "ratingCount": "10000+"
//   }
// };


const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "@id":
    "https://www.sanavitravels.com/ac-bus-hire-in-pune#service",

  "name": "AC Bus Hire in Pune",

  "serviceType": "AC Bus Rental",

  "description":
    "Sanavi Travels provides AC buses on rent in Pune for family trips, corporate travel, weddings, picnics, group tours, events and outstation journeys with professional drivers.",

  "provider": {
    "@type": "LocalBusiness",
    "@id": "https://www.sanavitravels.com/#business",
    "name": "Sanavi Travels",
    "url": "https://www.sanavitravels.com/",
    "telephone": "+91-7387507373"
  },

  "areaServed": {
    "@type": "City",
    "name": "Pune",
    "containedInPlace": {
      "@type": "State",
      "name": "Maharashtra",
      "containedInPlace": {
        "@type": "Country",
        "name": "India"
      }
    }
  },

  "url":
    "https://www.sanavitravels.com/ac-bus-hire-in-pune"
};






  return (
    <div>
<Helmet>
  <title>
    AC Bus Hire in Pune | AC Bus Rental & Booking | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book an AC bus on rent in Pune with Sanavi Travels for family trips, corporate travel, weddings, picnics, group tours and outstation journeys with professional drivers."
  />

  <meta
    name="keywords"
    content="AC Bus Hire in Pune, AC Bus Rental Pune, AC Bus on Rent Pune, AC Bus Booking Pune, Private AC Bus Pune, AC Bus Hire Pune, Luxury AC Bus Pune, AC Bus Rental for Outstation Pune"
  />

  <link
    rel="canonical"
    href="https://www.sanavitravels.com/ac-bus-hire-in-pune"
  />

  {/* Open Graph */}
  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:title"
    content="AC Bus Hire in Pune | AC Bus Rental & Booking | Sanavi Travels"
  />

  <meta
    property="og:description"
    content="Hire an AC bus in Pune for family trips, corporate travel, weddings, picnics, group tours and outstation journeys with Sanavi Travels."
  />

  <meta
    property="og:url"
    content="https://www.sanavitravels.com/ac-bus-hire-in-pune"
  />

  <meta
    property="og:image"
    content="https://www.sanavitravels.com/images/ac-bus-hire-in-pune.jpg"
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


{/* <Helmet>
  <title>
    Call : +91 7387507373 | AC Bus Hire in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC bus hire in Pune with Sanavi Travels. Luxury AC buses, mini buses, 32 and 35 seater buses for corporate events, weddings, outstation travel, school trips, and family trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet> */}


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/ac-bus-hire-in-pune.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Acbushireinpune;